import React, { useState } from "react";
import "./Notifications.css";
import { useNavigate } from "react-router-dom";
import Notification_card from "./Notification_card/Notification_card";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import No_data from "../Common/No_data/No_data";
function Notifications() {
  
  const navigate = useNavigate();

 const [notifications, setNotifications] = useState([
  {
    id: 1,
    title: "Login Information",
    date: "2026-02-11 | 16:25:09",
    message: "Your account has been login at 2026-02-11 | 16:25:09",
  },
  {
    id: 2,
    title: "Login Information",
    date: "2026-02-11 | 16:25:09",
    message: "Your account has been login at 2026-02-11 | 16:25:09",
  },
  {
    id: 3,
    title: "Login Information",
    date: "2026-02-11 | 16:25:09",
    message: "Your account has been login at 2026-02-11 | 16:25:09",
  },
  {
    id: 4,
    title: "Login Information",
    date: "2026-02-11 | 16:25:09",
    message: "Your account has been login at 2026-02-11 | 16:25:09",
  }
]);

   const deleteNotification = (id) => {
    setNotifications((prev) =>
      prev.filter((item) => item.id !== id)
    );
  };


  return (
    <div className="notification-page-wrapper">
        
       <Common_white_header headingText={"Notification"} />

      <div className="notification-list">
       {notifications.map((item) => (
          <Notification_card
            key={item.id}
            id={item.id}
            title={item.title}
            date={item.date}
            message={item.message}
            onDelete={deleteNotification}
          />
        ))}


        <No_data/>
      </div>
    </div>
  );
}

export default Notifications;